import React from 'react';
import { Select, Input, InputNumber, Card } from 'components';
import { CreateListingCardProps, LocationFields } from '../types';
import { StyledGrid } from './StyledComponents';

type LocationProps = CreateListingCardProps<LocationFields>;

const frontsOnOptions = ['North', 'South', 'East', 'West'] as const;

const Location: React.FC<LocationProps> = ({
  subtype,
  dir_cross,
  fronts_on,
  taxes,
  possession,
  occupancy,
  holdover,
  legal_description,
  setListing,
}) => (
    <Card type="primary" title="Location" id="location">
      <StyledGrid $columns={3}>
        <Input
          label="Directions / Cross Street"
          value={dir_cross}
          onChange={({ target: { value } }) =>
            setListing(prev => ({ ...prev, dir_cross: value }))
          }
          data-cy="listing-dir-cross"
        />
        <Select
          allowClear
          label="Fronts On"
          value={fronts_on}
          onChange={(value: (typeof frontsOnOptions)[number]) =>
            setListing(prev => ({ ...prev, fronts_on: value }))
          }
          options={frontsOnOptions.map(value => ({ label: value, value }))}
          data-cy="listing-fronts-on"
        />
        {subtype === 'sale' && (
          <InputNumber
            label="Taxes"
            value={taxes}
            onChange={value => {
              let newTaxes: number;
              if (typeof value === 'number') newTaxes = value;
              else if (value === undefined) newTaxes = undefined;
              else if (Number.isNaN(Number(value))) newTaxes = undefined;

              setListing(prev => ({
                ...prev,
                taxes: newTaxes,
              }));
            }}
            data-cy="listing-taxes"
          />
        )}
        <Input
          label="Possession"
          value={possession}
          onChange={({ target: { value } }) =>
            setListing(prev => ({ ...prev, possession: value }))
          }
          data-cy="listing-possession"
        />
        <Input
          label="Occupancy"
          value={occupancy}
          onChange={({ target: { value } }) =>
            setListing(prev => ({ ...prev, occupancy: value }))
          }
          data-cy="listing-occupancy"
        />
        <Input
          label="Holdover"
          value={holdover}
          onChange={({ target: { value } }) =>
            setListing(prev => ({ ...prev, holdover: value }))
          }
          data-cy="listing-holdover"
        />
        <Input
          label="Legal Description"
          value={legal_description}
          onChange={({ target: { value } }) =>
            setListing(prev => ({ ...prev, legal_description: value }))
          }
          data-cy="listing-legal-description"
        />
      </StyledGrid>
    </Card>
  );

export default React.memo(Location);
